<form #formRegister="ngForm" name="formRegister" (submit)="handleSubmitEmailCheck(formRegister.value, $event)" novalidate>
  <h3>{{ appCopy.panelHeader['title'+selectedLanguage] }}</h3>
  <p class="text-muted">{{ appCopy.panelHeader['titleDescription'+selectedLanguage] }}</p>
  <div class="form-group">
    <input class="form-control"
            [ngClass]="{ 'has-error' : username.invalid && username.dirty}"
            id="Username" 
            name="Username" 
            type="email" 
            #username="ngModel"
            [pattern]="emailPattern"
            ngModel 
            required
            appCheckEmpty>
    <label class="control-label" for="username">{{ appCopy.panelHeader['emailPlaceholder'+selectedLanguage] }}</label>
    <i class="icon control-validation-state"></i>
    
    <p class="help-block text-danger" *ngIf="username?.errors?.pattern">{{ appCopy.panelHeader['validEmail'+selectedLanguage] }}</p>
    <p class="help-block text-danger" *ngIf="username.invalid && username.dirty && !username?.errors?.pattern">{{ appCopy.panelHeader['warningEmail'+selectedLanguage] }}</p>
  </div>

  <button type="submit" class="btn btn-purple btn-lg btn-block" [disabled]="formRegister.invalid">
    <div class="loader-container-btn" *ngIf="showLoader">
      <div class="loader loader--white">
        <svg class="circular" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" />
        </svg>
      </div>
    </div>
    {{ appCopy.panelHeader['btnNext'+selectedLanguage] }} 
  </button>
  
  <div class="hr-text text-center text-muted margin-top-32 margin-bottom-32">
    <span>{{ appCopy.panelHeader['orText'+selectedLanguage] }}</span>
  </div>
  <button type="button" class="btn btn-primary btn-ghost btn-lg btn-block" (click)="goToLogin()">
    {{ appCopy.panelHeader['btnLogin'+selectedLanguage] }}
  </button>
</form>